import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import React, {useEffect, useState} from "react";
import Form from "../../components/common/form/Form";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {getFormData} from "../../models/branchSubscriptionModel";
import {branchSubscriptionSchema} from "../../schema/branchSubscriptionSchema";
import {fetchBranchList, fetchRestaurantList, fetchSubscriptionList} from "../../store/list-slice";
import {assignBranchSubscription ,resetAssignStatus} from "../../store/branch-subscription-slice";


const AssignBranchSubscription = () => {
    const navigator = useNavigate();
    const dispatch = useDispatch();
    const list = useSelector(state => state.list);
    const [formData, setFormData] = useState();

    const {
        assignStatus,
        error
    } = useSelector(state => state.globalSubscription);

    useEffect(() => {
        if (assignStatus === "success") {
            dispatch(resetAssignStatus());
            navigator("..");
        }
    }, [assignStatus, dispatch, navigator]);


    useEffect(() => {
        dispatch(fetchSubscriptionList());
        dispatch(fetchRestaurantList());
    }, [dispatch]);


    const inputChangeHandler = (field, data) => {
        if (field === "restaurant") {
            dispatch(fetchBranchList(data.restaurant));
            setFormData({...data, branch: ''});
        }
    };

    const formSubmitHandler = (data) => {
        const modifiedData = {template: data.template, id: data.branch};
        dispatch(assignBranchSubscription(modifiedData));
    };

    const formCancelHandler = () => {
        navigator(".."); // Adjust the navigation path as needed
    };

    const schema = branchSubscriptionSchema({list}); // Define this schema in your schema directory
    const initialData = getFormData(); // Define how initial data is fetched or structured

    return (
        <>
            <SubHeader title="Assign Subscription">
                <Button to="../" className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                <div className="row">
                    <div className="col-12 col-lg-8 col-xl-4">
                        <Form
                            onFormSubmit={formSubmitHandler}
                            onFormCancel={formCancelHandler}
                            onInputChange={inputChangeHandler}
                            schema={schema}
                            inline={false}
                            initialData={initialData}
                            updatedData={formData}
                            status={assignStatus}
                            error={error}
                        />
                    </div>
                </div>
            </div>
        </>
    )

}

export default AssignBranchSubscription;
